module.exports = __webpack_public_path__ + "img/save_image.3556d8ab.gif";